module.exports = __webpack_public_path__ + "img/SD.b8d99dbb.svg";